import { useContext } from 'react';
import { PendingOrdersContext } from '../contexts/pending-orders-context-types';

export function usePendingOrders() {
  const context = useContext(PendingOrdersContext);

  if (!context) {
    throw new Error('usePendingOrders must be used within a PendingOrdersProvider');
  }

  return context;
}
